<template>
    <Navbar v-if="isOrgValidated() && !isOnAttendancePage()" />
    <div :class="isOnAttendancePage() ? 'row g-0' : 'app-wrapper'">
        <router-view />
        <Footer />
        <Loader v-show="loading" />
        <button type="button" class="btn text-white rounded-circle position-fixed bottom-0 end-0 m-4 shadow"
            style="width:60px;height:60px;z-index:3;background-color:#209CEE;border-color:#209CEE;"
            data-bs-toggle="offcanvas" data-bs-target="#offcanvasChat" v-if="pulsarConnected && !isOnAttendancePage()">
            <i class="bi bi-chat-dots-fill fs-4"></i>
        </button>
        <Chat/>
    </div>
</template>

<script>
import Navbar from "@/components/admin/Navbar.vue";
import Footer from "@/components/admin/Footer.vue";
import Loader from "@/components/Loader.vue";
import Chat from "@/components/admin/Chat.vue";

import { emitter } from '@/services/emitter.service';
import { healthCheck } from "@/services/health-check-service";
export default {
    components: {
        Navbar,
        Footer,
        Loader,
        Chat
    },
    data() {
        return { 
            loading: false,
            pulsarConnected: false
        };
    },
    created() {
        emitter.on("showLoader", (e) => {
            this.loading = e;
        });

        healthCheck().then(r => {
            this.pulsarConnected = r.data.entries.HealthCheckHandler.data.pulsarConnected;
        });
    },
    mounted() {
        document.querySelectorAll("link[data-theme]").forEach(el => el.remove());

        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "/css/main.css";
        link.dataset.theme = "true";

        document.head.appendChild(link);
    },
    methods: {
        isOrgValidated() {
            return localStorage.getItem("org") != undefined;
        },
        isOnAttendancePage() {
            return this.$route.path.includes("attendance");
        }
    },
}
</script>